import { H2 } from "components/atoms/H2";
import { useFavorite } from "features/shared/hooks/useFavorite";
import { Fortune, TelFortune } from "shared/types";

import { useFetchData } from "../hooks/useFetchData";
import useNavigation from "../hooks/useNavigation";

import { menuHelper } from "../utils/menuHelper";
import Link from "next/link";
import dynamic from "next/dynamic";
import { MenuGallelyCard } from "shared/features/Menu/components/MenuGallelyCard";
import { useMenuContext } from "../hooks/useMenuContext";

const List = dynamic(
  async () => (await import("shared/components/molecules/List")).List
);

const MenuListSkeleton = dynamic(
  async () =>
    (await import("components/molecules/MenuListSkeleton")).MenuListSkeleton
);

const TagMenu = dynamic(
  async () => (await import("features/menu/components/TagMenu")).TagMenu
);

const Carousel = dynamic(
  async () => (await import("shared/components/atoms/Carousel")).Carousel
);

export const RelatedMenuList = () => {
  const { menu } = useMenuContext();
  const { fortuneTellerMenus, categoryMenus } = useFetchData(menu);
  const { goToCategory } = useNavigation(menu);
  const { onClickFavorite } = useFavorite();

  const renderAnotherMenu = (menu: Fortune | TelFortune) => {
    const { menuPagePath } = menuHelper(menu);
    return (
      <Link href={menuPagePath}>
        <a>
          <MenuGallelyCard
            tw="w-full"
            menu={menu}
            onClickFav={onClickFavorite}
          />
        </a>
      </Link>
    );
  };

  const renderPopularMenu = (menu: Fortune | TelFortune) => {
    const { menuPagePath } = menuHelper(menu);
    return (
      <Link href={menuPagePath}>
        <a>
          <MenuGallelyCard menu={menu} onClickFav={onClickFavorite} />
        </a>
      </Link>
    );
  };

  return (
    <>
      <div tw="mt-[26px] px-5">
        <H2>{menu?.fortuneTeller.name}先生の他のメニュー</H2>
        <div tw="mt-5">
          {fortuneTellerMenus.length > 0 ? (
            <List
              columns={2}
              data={fortuneTellerMenus}
              renderItem={renderAnotherMenu}
              bottomBorder={false}
              itemPadding
            />
          ) : (
            <MenuListSkeleton />
          )}
        </div>
      </div>
      {menu?.divinationTags.map((tag) => (
        <div key={tag.id} tw="my-10">
          <TagMenu tag={tag} />
        </div>
      ))}
      {menu?.sceneTags.map((tag) => (
        <div key={tag.id} tw="my-10">
          <TagMenu tag={tag} />
        </div>
      ))}
      <div tw="my-10">
        <H2 tw="px-5" readMore onClick={goToCategory}>
          {menu?.category.name}に関する人気メニュー
        </H2>
        {categoryMenus.length > 0 ? (
          <Carousel data={categoryMenus} renderItem={renderPopularMenu} />
        ) : (
          <MenuListSkeleton tw="mt-5 px-5" />
        )}
      </div>
    </>
  );
};
